import styled from 'styled-components';

export const ModalContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 2000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-width: 400px;
  max-width: 700px;
`;

export const QrCodeContainer = styled.div`
  margin: 10px 0;
`;
export const QrCodeContent = styled.img`
  width: 256px;
  height: 256px;
  display: block;
  margin: auto;
`;

export const WaitingQrCodeContent = styled.p`
  font-size: 14px;
  color: #666;
  text-align: center;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 350px;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
`;

export const ConnectingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 14px;
  height: 350px;
`;

export const ConnectingTitle = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: #2e7d32;
  text-align: center;
  margin: 0;
`;
